<template>
  <modal
    id="business-logout-modal"
    :show="show"
    tracking-name="popup-20210205-business_logout"
    @open="$emit('toggle', true)"
    @close="$emit('toggle', false)"
  >
    <div class="business-logout-modal">
      <div class="container">
        <h2 class="business-logout-modal__headline">
          {{ $t("headline") }}
        </h2>
        <p class="business-logout-modal__text">
          {{ $t(`${i18nKey}`) }}
        </p>
        <div class="business-logout-modal__footer">
          <button class="business-logout-modal__decline" @click="$emit('toggle', false)">
            {{ $t("decline") }}
          </button>
          <button-component class="business-logout-modal__confirm" :href="$options.logoutPath">
            {{ $t("confirm") }}
          </button-component>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/shared/modal"
import ButtonComponent from "@/shared/button"
import globals from "@/utils/globals"

let logoutPath = (globals.business && globals.business.logoutPath) || globals.routes.logout

if (!logoutPath) {
  logoutPath = globals.routes.logout
}

export default {
  name: "BusinessLogoutModal",
  components: {
    Modal,
    ButtonComponent
  },
  model: {
    prop: "show",
    event: "toggle"
  },
  logoutPath: logoutPath,
  props: {
    show: { type: Boolean, default: false },
    i18nKey: { type: String, default: "default" }
  },
  i18n: {
    messages: {
      en: {
        headline: "You need to sign up with a different email",
        default:
          "We’re sorry but you cannot create a Team with your current account. Would you like us to log you out so you can start over with a new account?",
        teamOwner:
          "We’re sorry but it looks like you are already a Team owner. You need to sign up for a new account in order to proceed. Would you like us to log you out so you can do this?",
        teamMember:
          "We’re sorry but it looks like you are already a member of a Team. You need to sign up for a new account in order to proceed. Would you like us to log you out so you can do this?",
        decline: "No, thank you",
        confirm: "Log out and continue"
      },
      de: {
        headline: "Registrieren Sie sich mit einer anderen E-Mail-Adresse",
        default:
          "Mit dieser E-Mail-Adresse können Sie keinen Blinkist Business Account erstellen. Wollen Sie sich ausloggen und einen neuen Account erstellen?",
        teamOwner:
          "Sieht aus, als wären Sie bereits der Team-Admin. Um weiterzumachen benötigen Sie einen neuen Account. Wollen Sie sich ausloggen und einen neuen Account erstellen?",
        teamMember:
          "Sieht so aus, als hätten Sie bereits ein Blinkist Business Abo, yay! Um weiterzumachen benötigen Sie einen neuen Account. Wollen sie sich trotzdem ausloggen und einen neuen Account erstellen?",
        decline: "Nein, danke",
        confirm: "Ausloggen"
      }
    }
  }
}
</script>

<style lang="scss">
.business-logout-modal {
  max-width: $x-wide-block-width;
  padding-top: $spacing-48;
  padding-bottom: $spacing-48;

  &__headline {
    @include h2;
  }

  &__footer {
    display: flex;
    justify-content: flex-end;
  }

  &__decline {
    cursor: pointer;
  }

  &__confirm {
    margin-left: $spacing-16;
  }
}
</style>
